import * as React from 'react';

export const veFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_264)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#001F7E'
            />
            <mask
                id='mask0_1_264'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_264)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 13.3333H28V20H0V13.3333Z'
                    fill='#D00C27'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 10.6667H9.33333V12H8V10.6667ZM10.6667 9.33333H12V10.6667H10.6667V9.33333ZM16 9.33333H17.3333V10.6667H16V9.33333ZM18.6667 10.6667H20V12H18.6667V10.6667ZM13.3333 8H14.6667V9.33333H13.3333V8Z'
                    fill='#BCC9F0'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H28V6.66667H0V0Z'
                    fill='#FFCD00'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_264'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
